<template>
  <div class="blog-home">
        <b-container fluid >
            <b-row class="mycontainer-main " >
                <b-col cols="12" md="4" class="pl-5 leftcontent" >
                    <img
                        v-if="post.data.featured_image"
                        :src="post.data.featured_image"
                        alt=""
                        style="width: 50%;"></img> 
                    <h3 style="font-weight: bold;" class="mt-2">{{ post.data.title }}</h3>
                    <h5 > {{ post.data.author.first_name }}  {{ post.data.author.last_name }}</h5>
                    <b-button squared variant="outline-dark" class="mt-3 shadow"  @click="goBack">{{ $t('common.goback') }} </b-button>   
                </b-col>

                <b-col cols="12" md="7" class="blog-info py-3">
                    <b-card border-variant="white">
 
                        <div id="blogdata" v-html="post.data.body" class="mt-3" ></div>

                        <div>
                          <hr>
                          <p><strong>Beauté Intégrale</strong><p>
                          <p>Clinique de soins professionnels de beauté, située dans la ville de Québec et spécialisée dans la consultation en ligne en télé-esthétique.</p> 
                        </div>

                      <b-row align-h="around" class="text-center mt-5">
                      <b-col>                        
                        <router-link
                        v-if="post.meta.previous_post"
                        :to="/blog/ + post.meta.previous_post.slug"
                        class="button"
                        >
                        <b-button squared variant="dark" size="md" class="align-self-end main-button shadow mt-2 ">
                          <b-icon icon="arrow-left" variant="white" aria-hidden="true"></b-icon>
                          {{ post.meta.previous_post.title }}</b-button>
                        
                        </router-link>
                      </b-col>
                    <b-col>
                        <router-link
                        v-if="post.meta.next_post"
                        :to="/blog/ + post.meta.next_post.slug"
                        class="button"
                        >
                        <b-button squared variant="dark" size="md" class="align-self-end main-button shadow mt-2 ">
                          {{ post.meta.next_post.title }}
                          <b-icon icon="arrow-right" variant="white" aria-hidden="true"></b-icon>
                          </b-button>
                        
                        </router-link>
                      </b-col>
                      </b-row>
                    </b-card>
                </b-col> 
            </b-row>            
        </b-container>
  </div>
</template>


<script>
import Butter from 'buttercms';
export const butter = Butter('c02e20211ec08fd909ab2e9e91553eb8d35e5cff');

  export default {
    name: 'blog-post',
    data() {
      return {
        post: null
      }
    },
    methods: {
      getPost() {
        butter.post.retrieve(this.$route.params.slug)
          .then(res => {
            this.post = res.data
          }).catch(res => {
            console.log(res)
          })
      },
        goBack (){
            this.$router.go(-1)
        }
    },
    created(){
        this.getPost()
    },
    watch: {
      $route: {
        immediate: true,
        handler(to, from) {
          this.getPost()
        }
      }
    },
    computed: {
     locale(){
          return this.$i18n.locale
      },
    },
}
</script>


<style scoped>
.mycontainer-main {
    min-height:  calc(90vh);
}
.leftcontent {
    padding-top: 20vh;
    padding-bottom: 10vh;
}
.card-img-top {
    width: 100%;
    height: 15rem;
    object-fit: cover;
}
.blog-info >>> .image img {
    width: 100% !important;
}
.blog-info >>> h3 {
    margin-top: 40px !important;
    line-height: 1.2em !important;
    font-weight: bold;

}
.blog-info >>> h5 {
    margin-top: 30px !important;
    line-height: 1.2em;
    font-weight: bold;
}
#blogdata >>> p {
    margin-top: 5px !important;
    padding-left: 5px !important;
}
#blogdata >>> a {
    color: blue;
}
#blogdata >>> img {
    margin-top: 10px;
    margin-bottom: 10px;
}
</style>


// WEBPACK FOOTER //
// src/pages/BlogPost.vue